<div class="spare-parts">
  <h3 class="spare-parts__heading">{{ title }}</h3>
  <ng-content></ng-content>
</div>
